exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-70px[data-v-d84f8022]{margin-top:70px}", ""]);

// exports
